<template>
  <v-content>
    <v-container :fluid="this.$vuetify.breakpoint.mdAndDown">
      <div class="pt-4 px-4">
        <fma-lookahead
          :items="searchTerms"
          :on-search-submit="searchSubmitted"
        />
      </div>
      <h1
        :class="[
          this.$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-3',
          'secondary--text',
          'font-weight-bold',
          'pl-4',
          'pt-2'
        ]"
      >
        Categories
      </h1>
      <tile-grid>
        <v-flex
          v-for="{ title, description, image_id, id } in categories"
          :key="id"
          :class="`lg${tileWidth}`"
          :style="`max-width: ${(tileWidth / 12) * 100}%;`"
        >
          <fma-tile
            :title="title"
            :description="description"
            :imgsrc="images[image_id]"
            button-text="Learn More"
            :action-on-tile-click="() => categoryClicked(id)"
          />
        </v-flex>
      </tile-grid>
    </v-container>
  </v-content>
</template>

<script>
import _ from "lodash";
import TileGrid from "@/components/TileGrid.vue";
import FmaTile from "@/components/FmaTile.vue";
import FmaLookahead from "@/components/FmaLookahead.vue";

export default {
  components: {
    TileGrid,
    FmaTile,
    FmaLookahead
  },
  computed: {
    categories() {
      return _.sortBy(this.$store.state.categories, category => {
        return _.toUpper(category.title);
      });
    },
    searchTerms() {
      return this.$store.state.searchTerms;
    },
    services() {
      return this.$store.state.services;
    },
    images() {
      return this.$store.state.images;
    },
    tileWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 3; //TODO: is this right
      }
    }
  },
  watch: {
    categories(categories) {
      for (let { image_id } of categories) {
        this.$store.dispatch("fetchImage", { id: image_id });
      }
    }
  },
  mounted() {
    this.$store.dispatch("fetchCategories");
    this.$store.dispatch("fetchSearchTerms");
  },
  methods: {
    categoryClicked(categoryId) {
      this.$router.push({ name: "Listings", params: { categoryId } });
    },
    searchSubmitted(searchTerm) {
      this.$router.push({ name: "Search", params: { searchTerm } });
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";
</style>
